import { z } from 'zod';

/**
 * The kind of actor making a request to a Fragment API.
 *
 * - `human`           Dashboard user (Auth0). Identified by Auth0 `sub`; also
 *                    represented as a `User` document in the Global table.
 * - `service`         Fragment-internal service (e.g. Global API calling
 *                    Internal API). Identified by Auth0 `sub`.
 * - `customer_api_client` Customer-facing API client (Cognito). Identified by
 *                    Cognito `sub`; also lives as an `ApiClient` doc in the
 *                    Workspaces table.
 *
 * See the Permissions RFC for context.
 */
// `.brand()` hides `.options` on the wrapping schema, so the enum is kept
// un-branded for `principalTypes` and re-branded for `PrincipalTypeSchema`.
const PrincipalTypeEnum = z.enum(['human', 'service', 'customer_api_client']);

/**
 * `PrincipalType` carries the `SafeString` brand because every enum value is
 * runtime-safe (no `:`, `/`, `#`, or `{{handlebar}}`), so values can flow
 * into APIs that require `SafeString` (e.g. `SafeIdEncoder`) without a
 * per-call assertion.
 */
export const PrincipalTypeSchema = PrincipalTypeEnum.brand<'SafeString'>();

export type PrincipalType = z.infer<typeof PrincipalTypeSchema>;

export const principalTypes = PrincipalTypeEnum.options;
